import { render, staticRenderFns } from "./SocialCustomField.vue?vue&type=template&id=71b5d196&"
import script from "./SocialCustomField.vue?vue&type=script&lang=js&"
export * from "./SocialCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b5d196')) {
      api.createRecord('71b5d196', component.options)
    } else {
      api.reload('71b5d196', component.options)
    }
    module.hot.accept("./SocialCustomField.vue?vue&type=template&id=71b5d196&", function () {
      api.rerender('71b5d196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/SocialCustomField.vue"
export default component.exports